
<div class="bg-page-container we-have-moved-wrapper d-flex flex-column align-items-center justify-content-between h-100">

   <div class="we-have-moved d-flex flex-column align-items-center flex-grow-1 flex-shrink-0 mt-5 mb-4">

      <img src="https://swfclearningprod.blob.core.windows.net/cea/cea-has-moved-car.png" class="img-fluid">
      <h2 class="mt-5">College Entrance Advantage Has Moved</h2>
      <p class="content mt-1">
         Thanks for visiting. The College Entrance Advantage program is no longer supported through this site.
      <p>
      <p class="content mt-4">
         If you need help with your registration, or you're looking for current resources, please reach out to our Customer Service team. They'll be happy to assist you and send the correct registration link to access your digital college prep tools
      </p>
      <p class="content mt-4">
         ***If you already contacted Customer Care Center, and created the account for the new CED product, please login here: <a href="https://learn.collegeentranceadvantage.com">learn.collegeentranceadvantage.com</a>
      </p>
      <a class="btn btn-lg btn-primary contact mt-4" href="mailto:customercontact@southwestern.com">
         Contact Customer Support
      </a>

   </div>

</div>

